module.exports = __webpack_public_path__ + "img/girl-phone.ef89dffb.png";